import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';
import style from '../../../../pages/intermediary/intermediary.module.scss';
import { Transaction } from './TransactionsTableRow';

export const transactionsTableHeaderData: TableHeaderConfig<Transaction>[] = [
  {
    key: 'date',
    label: 'Date',
    className: `${style.headers} ${style.dateWidth}`
  },
  {
    key: 'transactionType',
    label: 'Transaction type',
    className: `${style.headers} ${style.hideTransactionType}`
  },
  {
    key: 'description',
    label: 'Description',
    className: `${style.headers} ${style.descriptionWidth}`
  },
  {
    key: 'transactionAmount',
    label: 'Transaction amount',
    className: style.headers,
    align: 'right'
  },
  {
    key: 'cumulativeTotal',
    label: 'Cumulative total',
    className: style.headers,
    align: 'right'
  }
];
